import type { Guide, GuideRecordHint } from '../types';

/**
 * S-24.10-04 — pytanie przy zwrocie do CS przypięte do pola (model rekordu zlecenia §6.1 P5; scenariusz e2e 26,
 * MIX-01:4 i :6). G1R — zwrócone z pytaniem przy polu „Cena”, G1Q — u Administracji
 * (`e2e/setup/scenario-state.mjs`). Nagrywarka tylko otwiera okno zwrotu, niczego nie wysyła.
 */
const CONTROL: GuideRecordHint = {
  description: 'prezlecenie u Administracji — z kolejki „Do kontroli”',
  listPath: '/pre-orders',
  listFilter: { intakeQueue: 'adm_control' },
};
const RETURNED: GuideRecordHint = {
  description: 'prezlecenie zwrócone do CS z pytaniem — z kolejki „Zwrócone z pytaniem”',
  listPath: '/pre-orders',
  listFilter: { intakeQueue: 'cs_returned' },
};

export const guide: Guide = {
  flagKey: 'intakeQuestionField',
  title: 'Pytanie przy zwrocie do CS przypięte do pola',
  whatItDoes:
    'Zwracając prezlecenie do CS, Administracja wskazuje pole, którego dotyczy pytanie — z listy pól obowiązkowych — albo zostawia pytanie ogólne. CS widzi pytanie przy nazwie pola na karcie obiegu, znacznik przy wierszu prezlecenia i treść pytania pod polem w „Popraw dane” i w „Danych dla importera”. Znacznik znika, gdy CS odpowie i przekaże prezlecenie ponownie. Historia prezlecenia ma nazwę pola.',
  audience: ['Administracja', 'CS'],
  presentationItems: ['S-24.10-04'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/control',
      record: CONTROL,
      target: 'intake-return-question',
      mockupTestId: 'adm-zlecenie-zwrot-cs',
      title: 'Zwrot z wyborem pola',
      description:
        'W oknie „Zwróć do CS z pytaniem” lista „Pytanie dotyczy pola” — pola obowiązkowe albo „ogólne (bez pola)”.',
      action: 'Kliknij „Zwróć do CS z pytaniem”, wybierz pole i wpisz pytanie.',
      recorder: {
        account: 'adm',
        demo: { kind: 'scenario', key: 'g1qPreOrderId' },
        actions: [{ kind: 'click', target: 'intake-return' }],
      },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: RETURNED,
      target: 'intake-open-question',
      title: 'Pytanie przy polu u CS',
      description: 'Karta obiegu mówi, którego pola dotyczy pytanie; w wątku przy zwrocie stoi nazwa pola.',
      action: 'Otwórz zwrócone prezlecenie.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'g1rPreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: RETURNED,
      target: 'intake-question-marker-*',
      title: 'Znacznik przy polu',
      description:
        'Przy wierszu pola stoi znacznik „Pytanie” — w dymku treść pytania. W formularzu danych pytanie stoi pod polem.',
      action: 'Najedź na znacznik, popraw pole i odpowiedz, przekazując prezlecenie ponownie.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'g1rPreOrderId' } },
    },
  ],
};
